/**
 * Practical email check for forms — rejects obvious junk ("we", "a@b") and
 * requires a domain with a TLD of at least two letters. Not a full RFC 5322 parse.
 */
export function isValidEmailAddress(email) {
  if (email == null || typeof email !== 'string') return false;
  const s = email.trim();
  if (s.length < 5) return false;
  return /^[^\s@]+@([^\s@]+\.)+[^\s@]{2,}$/i.test(s);
}
